// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3pOQf","title":"Images90_title__2YVIX","images":"Images90_images__1s7Wi"};